import { AxiosResponse } from 'axios';

enum DictionarysPoints {
  PROF_INDASTRIES = 'industries/mini',
  WORK_TYPE = 'getDictionary/workTypes',
  USER_PROFESSIONS = 'professions/mini',
  USER_COMPETENCES = 'competences/mini',
  PROF_STANDARS = 'prof-standards/mini',
  PAY_LEVELS = 'getDictionary/payLevels',
  USER_PROF_SPHERES = 'prof-spheres/mini',
  WORK_PLACES = 'getDictionary/workPlaces',
  WORK_SPHERES = 'getDictionary/workSpheres',
  PROGRAMM_TYPES = 'getDictionary/programType',
  EDUCATION_FORM = 'getDictionary/eventEduForm',
  USER_EDU_LEVEL = 'getDictionary/userEduLevel',
  CONSULTATIONS_TOPIC = 'getDictionary/ConsultationsTopic',
  ACTIVITY_LEVEL = 'getDictionary/activityLevel',
  ACTIVITY_MEMBER = 'getDictionary/activityMember',
  EDUCATION_MODES = 'getDictionary/educationModes',
  PFDOD_DISEASES = 'getDictionary/navPfdodDiseases',
  EDUCATION_CATEGORIES = 'getDictionary/eventEduCat',
  EDUCATION_LEVELS = 'getDictionary/educationLevels',
  EDUCATION_DURATIONS = 'getDictionary/eduDurations',
  EDUCATION_LEVEL = 'getDictionary/educationLevel',
  EDUCATION_TYPE = 'getDictionary/educationType',
  DRIVER_LICENSE = 'getDictionary/driversLicense',
  WORLD_LANGUAGES = 'getDictionary/worldLanguages',
  LANGUAGE_LEVEL = 'getDictionary/languageLevel',

  APPLICATION_TYPES = 'getDictionary/ApplicationTypes',
  APPLICATION_STATES = 'getDictionary/ApplicationStates',
  NOKO_PROGRESS_RESULT = 'getDictionary/NokoProgressResult',
  VACANCIES_PLACE_TYPE = 'getDictionary/vacanciesPlaceType',
  NOKO_COMPETITION_TYPES = 'getDictionary/NokoCompetitionTypes',
  NOKO_COMPETITION_LEVELS = 'getDictionary/NokoCompetitionLevels',
  VACANCIES_EMPLOYMENT_TYPE = 'getDictionary/vacanciesEmploymentType',
  REGIONS = 'getDictionary/regions',
  BLOG_EVENT_TYPES = 'getDictionary/blogEventTypes',
  ACTIVITY_ORDER_EDU_LEVEL_SPR = 'getDictionary/activityOrderEduLevel',
  EVENT_ORDER_EDU_LEVELS = 'getDictionary/orderEduLevel',
  PARTNER_ROLE_DICT = 'getDictionary/partnerRoleDict',
  WORK_SCHEDULE_DICT = 'getDictionary/workSchedule',
  EMPLOYMENT_DICT = 'getDictionary/employment',
  ORDER_CANCEL_REASON_DICT = 'getDictionary/orderCancelReasonDict',
  COP_MULTI_GET = 'cop-multi/get',
  ORGANIZATIONS_DICT = 'organizations/get',
}

interface IGetDictionary {
  id: Id;
  name: string;
}

type Id = string | number;
type Dictionary = AxiosResponse<Array<IGetDictionary>>;

export { DictionarysPoints, Dictionary };



// WEBPACK FOOTER //
// ./src/services/dictionary/types.ts